import L from 'leaflet';

const createTruckIcon = (color: string): L.Icon => {
  const svgIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" 
         fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14 18V6a4 4 0 0 0-4 0v11a1 1 0 0 0-1 1h2a1 1 0 0 0 1-1v-1"/>
      <path d="M5 18H6a1 1 0 0 0 1-1v-3.65a1 1 0 0 0 .22-.624l4-5.45a1 1 0 0 1 .78-.376H21.5a.7.7 0 0 1 .5 1.21L20 10l2 2.5a.7.7 0 0 1-.5 1.21H12"/>
      <circle cx="7" cy="18" r="2"/>
      <circle cx="17" cy="18" r="2"/>
    </svg>
  `;
  
  return new L.Icon({
    iconUrl: `data:image/svg+xml;base64,${btoa(svgIcon)}`,
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
    className: 'truck-marker'
  });
};

export const truckIcon = createTruckIcon('#1e40af');
export const selectedTruckIcon = createTruckIcon('#dc2626');
export const inactiveTruckIcon = createTruckIcon('#6b7280');